<template>
  <div class="navbar-component">
    <nav class="navbar is-fixed-top navbar-fixed" role="navigation" aria-label="main navigation">
      <div class="navbar-brand">
        <a class="navbar-item ml-4 my-1" @click="reload()">
          <img src="@/assets/logo.png">
        </a>
      </div>
    </nav>
  </div>
</template>

<script>

export default {

  name: 'navbar',

  methods: {
    reload() {
      const route = this.$route.path;
      if (route === '/') {
        return location.reload();
      }
      this.$router.push('/')
    }
  }

}

</script>

<style lang="scss" scoped>
.navbar-component {
  .navbar {
    z-index: 100;
    width: 100%;
    overflow-x: hidden;

    .navbar-brand {
      .navbar-item {
        display: flex;
        align-items: center;
        
      }
    }
  }
  
  @media screen and (max-width: 768px) {
    .navbar {
      
      .navbar-item {
        padding: 0.5rem;
      }
    }
  }
}
</style>
